var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.291,
    height: 36.291,
    viewBox: "0 0 36.291 36.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send_b",
    transform: "translate(-4466.057 -2310.85)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 18.145,
    cy: 18.145,
    r: 18.145,
    transform: "translate(4466.057 2310.85)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M4473.164,2337.545a14.469,14.469,0,0,1,12.932-13.295v-5.319l9.144,9.2-9.084,9.264v-5.5S4480.134,2330.34,4473.164,2337.545Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBlack);
export default __webpack_public_path__ + "static/media/send_black.0b6dba0bd130585e6a68d9d077ff8791.svg";
export { ForwardRef as ReactComponent };